import { Route } from '@/constants';
import { SidebarContentConfig } from '../types';


interface GetSidebarContentParams {
    t: (key: string) => string;
    path: string;
    isOpportunitiesActive: boolean;
    isMyDealsActive: boolean;
    myDealsOpen: boolean;
    isBuyingActive: boolean;
    isSellingActive: boolean;
    setMyDealsOpen: (open: boolean) => void;
}

export const getSidebarContent = ({
    t,
    path,
    isOpportunitiesActive,
    isMyDealsActive,
    myDealsOpen,
    isBuyingActive,
    isSellingActive,
    setMyDealsOpen,
}: GetSidebarContentParams): SidebarContentConfig => [
        {
            key: 'platform',
            label: 'Platform',
            items: [
                {
                    key: 'opportunities',
                    label: t('Opportunities'),
                    tooltip: t('Opportunities'),
                    to: Route.Home,
                    icon: 'trending-up',
                    isActive: isOpportunitiesActive,
                },
                {
                    key: 'my-deals',
                    label: t('My Deals'),
                    tooltip: t('My Deals'),
                    icon: 'briefcase-business',
                    isActive: isMyDealsActive,
                    isOpen: myDealsOpen,
                    onOpenChange: setMyDealsOpen,
                    items: [
                        { key: 'my-deals-buying', label: t('Buying'), to: Route.Buying, isActive: isBuyingActive },
                        { key: 'my-deals-selling', label: t('Selling'), to: Route.Selling, isActive: isSellingActive },
                    ],
                },
                {
                    key: 'services',
                    label: t('Advisors & Services'),
                    tooltip: t('Advisors & Services'),
                    to: Route.Services,
                    icon: 'people',
                    isActive: path.startsWith(Route.Services),
                },
            ],
        },
        {
            key: 'market-intelligence',
            label: 'Market Insights (Business)',
            items: [
                {
                    key: 'prices',
                    label: t('Asset Prices'),
                    tooltip: t('Asset Prices'),
                    to: Route.Prices,
                    icon: 'graph-bar',
                    isActive: path === Route.Prices,
                },
                {
                    key: 'transactions',
                    label: t('Transactions'),
                    tooltip: t('Transactions'),
                    to: Route.Transactions,
                    icon: 'file-text',
                    isActive: path === Route.Transactions,
                },
            ],
        },
    ];
